<div class="content-logo">
  <img proLogoImg alt="logo" class="content-logo__logo">
</div>
<div class="containerNOTE">
  <div class="contentNOTE">
    <div>
      <p [innerHTML]="contentNOTE.noteText"></p>
    </div>
    <div>
      <span>{{'finish_note_destinatario'| translate }}</span>
      <p>{{contentNOTE.recipient}}</p>
    </div>
    <div>
      <span>{{'finish_note_cert'| translate }}</span>
      <p>{{contentNOTE.publicKey}}</p>
    </div>
    <div>
      <span>{{'finish_note_idcert'| translate }}</span>
      <p>{{contentNOTE.operationId}}</p>
    </div>
    <div>
      <span>{{'finish_note_huella'| translate }}</span>
      <p>{{contentNOTE.documentHash}}</p>
    </div>
    <div>
      <span>{{'finish_note_certinfo'| translate }}</span>
      <p>{{contentNOTE.certInfo}}</p>
    </div>
    <div>
      <span>{{'newcircuit_form_campo_4'| translate }}:</span>
      <div class="docs" *ngFor="let doc of documents">
        <p>{{doc.title}}</p>
        <p>CSV: {{doc.csv}}</p>
      </div>
    </div>
    <div class="content__actions">
      <signaturit-button class="customBtn" text="{{'finish_note_btn_reject' | translate }}" type="secondary" size="md"
        (click)="onReject()" *ngIf="operationType !=='QERDS'">
      </signaturit-button>
      <signaturit-button class="customBtn" text="{{'finish_note_btn_accept' | translate }}" type="primary" size="md"
        (click)="finishOperation()" [showLoaderWithText]="isLoading">
      </signaturit-button>
    </div>
  </div>
</div>